import { render } from "./transactiontable.vue?vue&type=template&id=3db3d0f2"
import script from "./transactiontable.vue?vue&type=script&lang=js"
export * from "./transactiontable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__